// @flow
import React, { useState } from 'react';
import Slider from 'react-slick';
import { CallToAction } from 'components/atoms/callToAction';
import { ShareButton } from 'components/atoms/shareButton';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import IconDownArrowBlack from 'assets/images/downArrowBlack.png';
import type { VirtualTour } from 'types/project';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css'; // check you need to import the whole css?
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  tours: Array<VirtualTour>,
  onExploreClick: () => void,
};

export const VirtualTours = (props: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();
  const [viewVirtualTour, setViewVirtualTour] = useState(false);
  const mousePointers = viewVirtualTour ? 'all' : 'none';
  const virtualContainerOpacity = viewVirtualTour ? 1 : 0.2;
  const { height } = useViewport();

  const { tours } = props;
  if (!tours || tours.length === 0) {
    return null;
  }

  const settings = {
    className: 'slider variable-width',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: true,
    lazyLoad: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const renderContent = () => {
    return (
      <Slider ref={c => setSlider(c)} {...settings} style={{ height: '100%' }}>
        {tours.map((tour, idx) => {
          return (
            <div className={'virtual-tour'} style={{ height }}>
              {!viewVirtualTour && (
                <Button
                  variant="dark"
                  size="lg"
                  onClick={() => setViewVirtualTour(true)}
                >
                  + Click to view virtual tour
                </Button>
              )}
              <div
                key={idx}
                className={'virtual-tour-container'}
                dangerouslySetInnerHTML={{ __html: tour.view }}
                style={{
                  pointerEvents: mousePointers,
                  opacity: virtualContainerOpacity,
                }}
              />
            </div>
          );
        })}
      </Slider>
    );
  };

  // Render footer
  const onExploreClick = e => {
    setViewVirtualTour(false);
    props.onExploreClick();
  };

  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  const renderFooter = () => {
    return (
      <div className="section-footer">
        <a href={'#products'} onClick={onExploreClick}>
          <img src={IconDownArrowBlack} alt={'explore'} />
        </a>
        <PaginationControl
          className={'section-footer-item'}
          theme={'light-theme'}
          currentIndex={activeSlide + 1}
          total={tours.length}
          onNextClick={next}
          onPreviousClick={previous}
        />
      </div>
    );
  };

  return (
    <div
      className={'section-container no-gutter virtual-tours'}
      style={{ height }}
    >
      <div className={'section-content'}>{renderContent()}</div>
      {renderFooter()}
    </div>
  );
};
